export enum OrderAlertType {
  NoAlert = 0,
  NoCustumer = 1,
  OrderIsLate = 2,
  NoShippingLine = 3,
  PaidPending = 4,
  OmniOrderWithOtherOpen = 5,
}